// @material-ui/core
import {
  Avatar,
  Card,
  CardContent,
  CardHeader,
  ClickAwayListener,
  Collapse,
  Grid,
  IconButton
} from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import classnames from "classnames";
import PropTypes from "prop-types";
import React from "react";
import { ItemCardActions } from "./actions";
// import subclasses
import { ItemCardMenu } from "./menu";
import { styles } from "./styles";

// export subclasses
export { ItemCardItem } from "./item";
export { ItemCardItemList } from "./item-list";
export { ItemCardActions } from "./actions";

class ItemCard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: null,
      expanded: false,
      anchorEl: null,
      isHover: false,
      isExpandable: Boolean(props.isExpandable)
    };
  }

  handleExpandClick = () => {
    this.setState({ expanded: !this.state.expanded });
  };

  handleClick = event => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleRequestClose = () => {
    this.setState({ anchorEl: null });
  };

  toggleHover = isHover => {
    this.setState({ isHover });
  };

  handleClickMenu = event => {
    this.setState({ isOpen: event.currentTarget });
  };

  handleCloseMenu = () => {
    this.setState({ isOpen: null });
  };

  render() {
    const { classes } = this.props;
    const open = Boolean(this.state.anchorEl);
    let menu = null;
    if (this.props.options) {
      menu = <ItemCardMenu open={open} />;
    }

    return (
      <Card
        className={classnames(
          "card",
          classes.card,
          this.props.className,
          !this.state.expanded && "collapsed"
        )}
        onMouseOver={() => this.toggleHover(true)}
        onFocus={() => this.toggleHover(true)}
        onMouseEnter={() => this.toggleHover(true)}
        onMouseLeave={() => this.toggleHover(false)}>
        <ClickAwayListener onClickAway={this.handleCloseMenu}>
          <Grid container alignItems="center" justify="flex-start" spacing={8}>
            <Grid item xs={8}>
              <CardHeader
                avatar={
                  this.props.avatar && (
                    <Avatar className={classes.avatar}>
                      {this.props.avatar.substr(0, 1)}
                    </Avatar>
                  )
                }
                classes={{ root: classes.cardRoot }}
                action={menu}
                title={this.props.title}
                subheader={this.props.subheader}
                onClick={this.handleExpandClick}
              />
            </Grid>

            <div className={classes.flexGrow} />

            <Grid item>
              <Collapse in={this.state.isHover} timeout="auto" unmountOnExit>
                <ItemCardActions
                  actions={this.props.actions}
                  expanded={this.state.expanded}
                  handleExpandClick={this.handleExpandClick}
                  isExpandable={this.props.isExpandable}
                  handleClick={this.handleClickMenu}
                  handleClose={this.handleCloseMenu}
                  isOpen={this.state.isOpen}>
                  {this.props.isExpandable &&
                    this.state.isHover && (
                      <IconButton
                        className={classnames(classes.expand, {
                          [classes.expandOpen]: this.state.expanded
                        })}
                        classes={{ root: classes.rootCardActionItem }}
                        onClick={this.handleExpandClick}
                        aria-expanded={this.state.expanded}
                        aria-label="Show more">
                        <ExpandMoreIcon />
                      </IconButton>
                    )}
                </ItemCardActions>
              </Collapse>
            </Grid>

            {!this.props.isExpandable && (
              <Grid item xs={12}>
                <CardContent>
                  <Grid container spacing={8}>
                    {this.props.children}
                  </Grid>
                </CardContent>
              </Grid>
            )}

            {this.props.isExpandable && (
              <Collapse in={this.state.expanded} timeout="auto" unmountOnExit>
                <Grid item xs={12}>
                  <CardContent>
                    <Grid container spacing={8}>
                      {this.props.children}
                    </Grid>
                  </CardContent>
                </Grid>
              </Collapse>
            )}
          </Grid>
        </ClickAwayListener>
      </Card>
    );
  }
}

ItemCard.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(ItemCard);



// WEBPACK FOOTER //
// ./src/library/card/item-card/index.js